import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Globe } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const GeoToast = () => {
  const { themeColor } = useTheme();
  const [visible, setVisible] = useState(false);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    const shown = sessionStorage.getItem('geo_shown');
    if (shown) return;

    const timer = setTimeout(() => {
      fetch('/api/geo', { cache: 'no-store' })
        .then(r => r.json())
        .then(data => {
          if (data.city || data.country) {
            setLocation(data);
            setVisible(true);
            sessionStorage.setItem('geo_shown', '1');
            setTimeout(() => setVisible(false), 5000);
          }
        })
        .catch(() => {});
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const locationText = location
    ? [location.city, location.region, location.country].filter(Boolean).join(', ')
    : '';

  return (
    <AnimatePresence>
      {visible && location && (
        <motion.div
          className="fixed bottom-6 left-1/2 z-50 glass-strong gradient-border px-6 py-3.5 rounded-2xl flex items-center gap-3 cursor-pointer"
          style={{ x: '-50%' }}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ type: 'spring', stiffness: 200, damping: 25 }}
          onClick={() => setVisible(false)}
          data-testid="geo-toast"
        >
          <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: `rgba(${themeColor.rgb}, 0.1)` }}>
            <Globe size={16} style={{ color: themeColor.primary }} />
          </div>
          <div>
            <p className="text-white text-sm font-medium flex items-center gap-1.5">
              <MapPin size={12} style={{ color: themeColor.primary }} />
              {locationText}
            </p>
            <p className="text-zinc-500 text-xs">adresinden bağlanıyorsunuz</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GeoToast;
